import axios from 'axios'

export const createBooking = (values, token) => {
    return new Promise((result, reject) => {
        axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + "/api/v1/rides/book", //159.89.236.159
            params: values,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err)
        })
    })
}